import { memo, useState } from 'react';

import Modal from '@zenbusiness/zui/Modal';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';
import { QRCodeSVG } from 'qrcode.react';

import RenderIf from '#client/components/RenderIf';

import { BoxStyled, QRCodeContainerStyled, ScanContainerStyled } from './QRCodeInstruction.styles';

const QRCodeInstruction = ({
  questionText = 'Fix this on mobile.',
  hintText = 'To retake a photo of this check for deposit, scan the QR code on your mobile device.',
  url,
  asImage = false,
  onClick,
  size = 41
}) => {
  const [isOpenBigSize, setIsOpenBigSize] = useState(false);

  return (
    <>
      <BoxStyled
        alignItems="center"
        direction="row"
      >
        <Text
          color="primary"
          size="lg"
        >
          <Text
            component="span"
            size="lg"
            weight="medium"
          >
            {questionText}
          </Text>{' '}
          {hintText}
        </Text>
        <ScanContainerStyled onClick={asImage ? onClick : () => setIsOpenBigSize(true)}>
          <RenderIf
            fallback={
              <QRCodeSVG
                size={size}
                value={url}
              />
            }
            when={asImage}
          >
            <SharedAsset
              alt=""
              height={size}
              src={url}
              width={size}
            />
          </RenderIf>
        </ScanContainerStyled>
      </BoxStyled>
      <Modal
        onClose={() => setIsOpenBigSize(false)}
        open={isOpenBigSize}
      >
        <QRCodeContainerStyled>
          <QRCodeSVG value={url} />
        </QRCodeContainerStyled>
      </Modal>
    </>
  );
};

QRCodeInstruction.propTypes = {
  url: PropTypes.string.isRequired,
  questionText: PropTypes.string,
  hintText: PropTypes.string,
  size: PropTypes.number,
  onClick: PropTypes.func,
  asImage: PropTypes.bool
};

export default memo(QRCodeInstruction);
